import { z } from 'zod';
import { defineEndpoint } from '../define';

/** Removes the machine and its samples; its runners stay (GitHub still lists them). */
export const deleteRunnerMachine = defineEndpoint({
  method: 'DELETE',
  path: '/v1/runner-monitor/machines/:machineId',
  params: z.object({ machineId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
